<section class="py-3">
  <div class="container-fluid card py-3">
    <div class="pt-3">
      <button type="button" class="btn btn-back mb-2" [routerLink]="'/dealer-list'">
        <fa-icon [icon]="faArrowLeft" class="me-1"></fa-icon> Back
      </button>
      <h3 class="text strat">
        {{selectedDealerId ? 'Update': ''}} Dealer Information
      </h3>
    </div>
    <form (ngSubmit)="saveDealerData()" [formGroup]="addDealerForm">
      
      <!-- Primary Details Row -->
      <div class="row pt-3">
        <!-- Name -->
        <div class="col-12 col-md-4 mb-3">
          <label for="dealerNameInput" class="form-label">Name<span class="text-danger">*</span></label>
          <input type="text" id="dealerNameInput" maxlength="25" class="form-control default-form-group-border"
            formControlName="name" required placeholder="Dealer name">
          @if (
            addDealerForm.get('name')?.invalid &&
            addDealerForm.get('name')?.touched
            ) {
            <div>
              <small class="text-danger">Please enter dealer name</small>
            </div>
          }
        </div>

        <!-- Dealer Code -->
        <div class="col-12 col-md-4 mb-3">
          <label for="branchCode" class="form-label">Dealer Code<span class="text-danger">*</span></label>
          <input type="text" maxlength="6" class="form-control default-form-group-border"
            formControlName="branchCode" id="branchCode" required placeholder="Dealer code">
          @if (
            addDealerForm.get('branchCode')?.invalid &&
            addDealerForm.get('branchCode')?.touched
            ) {
            <div>
              <small class="text-danger">Please enter branch code</small>
            </div>
          }
        </div>

        <!-- Phone Number -->
        <div class="col-12 col-md-4 mb-3">
          <label for="phoneNumber" class="form-label">Phone Number<span class="text-danger">*</span></label>
          <input class="form-control no-spinner default-form-group-border" type="number"
            formControlName="phoneNumber" id="phoneNumber" required placeholder="Phone number"
            (input)="onInput($event)">
          @if (
            addDealerForm.get('phoneNumber')?.invalid &&
            addDealerForm.get('phoneNumber')?.touched
            ) {
            <div>
              <small class="text-danger">Please enter valid phone number</small>
            </div>
          }
        </div>
      </div>

      <!-- Financial Details Row -->
      <div class="row pt-2">
        <!-- GST -->
        <div class="col-12 col-md-4 mb-3">
          <label for="gstNumber" class="form-label">GST</label>
          <input type="text" class="form-control default-form-group-border" formControlName="gstNumber"
            id="gstNumber" placeholder="GST" [maxLength]="15">
        </div>

        <!-- Credit Limit -->
        <div class="col-12 col-md-4 mb-3">
          <label for="creditLimit" class="form-label">Credit Limit</label>
          <input formControlName="creditLimit" id="creditLimit" type="number"
            class="form-control no-spinner default-form-group-border"
            placeholder="Credit limit amount" />
        </div>

        <!-- Credit Duration -->
        <div class="col-12 col-md-4 mb-3">
          <label for="delayAfterDelivery" class="form-label">Credit Duration</label>
          <input formControlName="delayAfterDelivery" id="delayAfterDelivery" type="number"
            class="form-control no-spinner default-form-group-border"
            placeholder="Credit Duration" value="1"/>
          @if (addDealerForm.get('delayAfterDelivery')?.touched && addDealerForm.get('delayAfterDelivery')?.invalid) {
            <div class="text-danger">
              @if (addDealerForm.get('delayAfterDelivery')?.hasError('min')) {
                <div>
                  Duration cannot be negative.
                </div>
              }
            </div>
          }
        </div>
      </div>

      <h3 class="text strat pt-3">Address Details</h3>
      
      <!-- Address Details Section -->
      <div class="row pt-2" formGroupName="address">
        <!-- Address Line 1 -->
        <div class="col-12 col-md-4 mb-3">
          <label for="line1" class="form-label">Address Line 1<span class="text-danger">*</span></label>
          <input type="text" class="form-control default-form-group-border" formControlName="line1"
            id="line1" required placeholder="Address line 1">
          @if (
            addDealerForm.get('address.line1')?.invalid &&
            addDealerForm.get('address.line1')?.touched
            ) {
            <div>
              <small class="text-danger">Please enter address line 1</small>
            </div>
          }
        </div>

        <!-- Address Line 2 -->
        <div class="col-12 col-md-4 mb-3">
          <label for="line2" class="form-label">Address Line 2</label>
          <input type="text" class="form-control default-form-group-border" formControlName="line2"
            id="line2" placeholder="Address line 2">
        </div>

        <!-- City -->
        <div class="col-12 col-md-4 mb-3">
          <label for="city" class="form-label">City<span class="text-danger">*</span></label>
          <input type="text" class="form-control default-form-group-border" formControlName="city"
            id="city" required placeholder="Enter city">
          @if (
            addDealerForm.get('address.city')?.invalid &&
            addDealerForm.get('address.city')?.touched
            ) {
            <div>
              <small class="text-danger">Please enter city</small>
            </div>
          }
        </div>

        <!-- State -->
        <div class="col-12 col-md-4 mb-3">
          <label for="state" class="form-label">State<span class="text-danger">*</span></label>
          <input type="text" class="form-control default-form-group-border" formControlName="state"
            id="state" required placeholder="State">
          @if (
            addDealerForm.get('address.state')?.invalid &&
            addDealerForm.get('address.state')?.touched
            ) {
            <div>
              <small class="text-danger">Please enter state</small>
            </div>
          }
        </div>

        <!-- Country -->
        <div class="col-12 col-md-4 mb-3">
          <label for="country" class="form-label">Country</label>
          <input type="text" class="form-control default-form-group-border" id="country"
            formControlName="country" placeholder="Country">
        </div>

        <!-- PIN Code -->
        <div class="col-12 col-md-4 mb-3">
          <label for="pincode" class="form-label">PIN Code<span class="text-danger">*</span></label>
          <input type="number" class="form-control default-form-group-border"
            formControlName="pincode" id="pincode" required (input)="onInputPincode($event)"
            placeholder="PIN code">
          @if (
            addDealerForm.get('address.pincode')?.invalid &&
            addDealerForm.get('address.pincode')?.touched
            ) {
            <div>
              <small class="text-danger">Please enter PIN code</small>
            </div>
          }
        </div>
      </div>

      <div class="text-danger mb-3">{{errorMessage}}</div>

      <!-- Action Buttons Row -->
      <div class="row pt-3">
        <div class="col-12 text-end p-3">
          <button type="button" class="btn btn-outline-dark m-2" [routerLink]="'/dealer-list'">Cancel</button>
          <button [disabled]="addDealerForm.invalid || isLoading" type="submit" class="btn app-btn-primary">
            {{selectedDealerId ? 'Update' : 'Submit'}}
            @if (isLoading) {
              <output class="spinner-border spinner-border-sm ms-1" aria-hidden="true"></output>
            }
          </button>
        </div>
      </div>

    </form>
  </div>
</section>